import { render } from "./AddDoctor.vue?vue&type=template&id=14aa2257&scoped=true"
import script from "./AddDoctor.vue?vue&type=script&lang=js"
export * from "./AddDoctor.vue?vue&type=script&lang=js"

import "./AddDoctor.vue?vue&type=style&index=0&id=14aa2257&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14aa2257"]])

export default __exports__